


export default function(state = {}, action){

  if (action.type === 'ADD_BRANCH'){
    var branch = action.payload.branch
    state = Object.assign({}, state)
    state[branch.id] = branch
  }

  if (action.type === 'ADD_FILE'){
    var { file, branchId } = action.payload
    // Check if its the schema file
    if (file.path == 'src/schema.js') {
      state = Object.assign({}, state)
      state[branchId] = Object.assign({}, state[branchId])
      state[branchId].schema = file.id
    }
  }

  if (action.type === 'MOVE_FILE'){
    var { file, oldBranchId, newBranchId } = action.payload
    if (file.path == 'src/schema.js') {
      state = Object.assign({}, state)
      state[oldBranchId] = Object.assign({}, state[oldBranchId])
      delete state[oldBranchId].schema
      state[newBranchId] = Object.assign({}, state[newBranchId])
      state[newBranchId].schema = file.id
    }
  }

  return state
}




// WEBPACK FOOTER //
// ./src/store/branches/reducer.js